import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { GreyInput } from '../components/inputs/greyInput';
import { minLengthValidator, maxLengthValidator } from '../helpers/validators';
import commonStyles from '../styles/commonStyles';
import { FormWrapper } from '../styles/styled';
import Loading from '../components/Loading';
import Colors from '../styles/colors';

const CreatePublisher = props => {
  const {
    name,
    onNameChange,
    onCreate,
    loading,
  } = props;

  const renderCreateButton = () => {
    const btnContent = loading ? (
      <Loading
        text="Processing"
        type="circle"
        align="center"
        size={30}
        fontSize={1.6}
        color="#fff"
        fill="#fff"
      />
    ) : 'CREATE ACCOUNT';

    return (
      <CreateButton
        id="signupCreateAccBtnTest"
        onClick={onCreate}
        className={`btn text-white xs-width-100 ${loading ? 'disabled' : ''}`}
      >
      {btnContent}
      </CreateButton>
    );
  };

  return (
    <FormWrapper className="text-left">
      <h1 className="title-large padding-five-bottom">Create Your Publisher Account</h1>
      <div className="text-large font-weight-700">
        Publisher name
      </div>
      <div className="text-medium font-italic padding-two-bottom">
        (this can be the name of your business, brand, team. You can always change it later.)
      </div>
      <GreyInput
        type="email"
        placeholder="Publisher name"
        onChange={onNameChange}
        value={name}
        validators={[minLengthValidator.bind(null, 1)]}
      />

      <div className="text-center">
        {renderCreateButton()}
      </div>
    </FormWrapper>
  );
};

const CreateButton = styled.button`
  width: 230px;
  height: 46px;
  background-color: ${props => props.processing ? '#404040' : Colors.mainOrange};
  font-size: 1.4rem;
  margin-top: 15px;
  margin-bottom: 15px;
`;

CreatePublisher.propTypes = {
  name: PropTypes.string,
  onNameChange: PropTypes.func,
  loading: PropTypes.bool,
  onCreate: PropTypes.func,
};

CreatePublisher.defaultProps = {
  name: '',
  onNameChange: () => {},
  loading: false,
  onCreate: () => {},
};

export default CreatePublisher;
